import React from 'react';
import { IThankYou } from 'services/ThankYouService';
import { enProductType } from 'enums/enProductType';
import { Info } from './Info';
import { Job } from './Job';
import { Ticket } from './Ticket';
import { Physical } from './Physical';

interface IProps {
  model: IThankYou;
}

export const Content = (props: IProps) => {
  switch (props.model.productType) {
    case enProductType.PHYSICAL:
      return <Physical model={props.model} />;
    case enProductType.SERVICE:
      return <Job model={props.model} />;
    case enProductType.TICKET:
      return <Ticket model={props.model} />;
    default:
      return <Info model={props.model} />;
  }
};